import { parseTerminalResult, type TerminalResult } from '../../hitl-types';
import type { ParsedToolOutput } from '../../tool-config-types';

export type { TerminalResult };

export const parseTerminalOutput = (output: unknown): ParsedToolOutput => {
  const result = parseTerminalResult(output);
  if (!result) return {};

  return {
    displayData: result,
    timing: result.duration ? { durationMs: result.duration } : undefined,
    metadata:
      result.exitCode !== undefined
        ? [{ label: 'Exit Code', value: String(result.exitCode) }]
        : [],
  };
};
